import React from 'react'
import { INavigationRoute } from '../NavigationBar/types'
import { NavigationMobileItemLink } from './components'

export interface INavigationMobileItemProps {
  route: INavigationRoute
  onClose: () => void
}

const COMPONENTS_BY_KEY = {
  link: NavigationMobileItemLink,
} as const

const getNavigationMobileItemComponent = (route: INavigationRoute) => {
  const { type } = route || {}
  switch (type) {
    case 'link':
    default:
      return COMPONENTS_BY_KEY.link
  }
}

const NavigationMobileItem = ({ onClose, route: routeProp }: INavigationMobileItemProps) => {
  const Component = getNavigationMobileItemComponent(routeProp)
  return <Component route={routeProp} onClose={onClose} />
}

export default NavigationMobileItem
